import { ControlPanelControllerInterface } from "@share/live-kit/interfaces/ControlPanelControllerInterface";
import { ShareControllerInterface } from "@share/live-kit/interfaces/ShareControllerInterface";

export class LiveKitControlPanelController implements ControlPanelControllerInterface {
    constructor(
        public readonly shareController: ShareControllerInterface
    ) {

    }
}
